import SimpleModal from "app/components/Modals/SimpleModal";
import {
  selectAllCompanyUsersById,
  selectUpdateUserByIdStatus,
  updateUserById,
} from "app/containers/Global/slice";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";
import TextInput from "app/storybookComponents/Forms/TextInput";
import SimpleModalFooter from "app/components/Modals/SimpleModalFooter";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  userAccountId: number | null;
}

const EditUserJobTitleModal = ({
  isOpen,
  onClose,
  userAccountId,
}: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const updateUserByIdStatus = useAppSelector(selectUpdateUserByIdStatus);
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const [jobTitle, setJobTitle] = useState("");

  useEffect(() => {
    if (userAccountId && usersById[userAccountId]) {
      setJobTitle(usersById[userAccountId].jobTitle ?? "");
    }
  }, [userAccountId, usersById]);

  return (
    <SimpleModal show={isOpen} onHide={onClose} title="Edit Job Title">
      <div className="column-gap-20px">
        <TextInput
          controlId="jobTitle"
          inputText={jobTitle}
          onTextChange={setJobTitle}
          inputLabel="Job Title"
          placeholder="Enter job title"
          className="column"
        />
        <SimpleModalFooter
          onPrimaryButtonClick={async () => {
            if (!userAccountId) {
              return;
            }
            await dispatch(
              updateUserById({
                userAccountId,
                payload: { jobTitle },
              })
            );
            onClose();
          }}
          primaryButtonText="Save"
          isPrimaryButtonDisabled={
            jobTitle === "" || updateUserByIdStatus === "loading"
          }
        />
      </div>
    </SimpleModal>
  );
};

export default EditUserJobTitleModal;
